import { render, staticRenderFns } from "./dandangguanli.vue?vue&type=template&id=747bd9be&"
import script from "./dandangguanli.vue?vue&type=script&lang=js&"
export * from "./dandangguanli.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports